<template>

    <div class="layout__container">

        <div class="layout__width-90 layout__padding-clear">

        <span class="text__colour-teal layout__position-left layout__padding-10-4 layout__width-100 text__align-center">
            <h3 class="layout__position-center">Modify Price Codes</h3><h4 class="layout__position-center">(Enter the record details and click to Save Changes or Cancel)</h4>
        </span>

            <el-form :model="price" ref="price" :rules="rules" class="layout__position-left layout__width-100">
                <div class="component__forms-3">
                    <p class="text_colour-909399 text__size-16">Code<span class="text__colour-red">*</span></p>
                    <p class="text__size-16" v-if="this.price.code">{{this.price.code}}</p>
                    <p class="text__size-16" v-else>-</p>
                    <br>
                </div>


                <div class="component__forms-3">
                    <el-form-item prop="type" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Type</div>
                        <el-select v-model="price.type" placeholder="Select Type" clearable="true">
                            <el-option
                                    v-for="type in ravensworth.priceCodeType.options"
                                    :key="type.id"
                                    :label="type.text"
                                    :value="type.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div class="component__forms-3">
                    <el-form-item prop="status" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Status</div>
                        <el-select v-model="price.status" placeholder="Select Status" clearable="true">
                            <el-option
                                    v-for="status in ravensworth.activeStatusWithHold.options"
                                    :key="status.id"
                                    :label="status.text"
                                    :value="status.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>


                <div class="layout__width-100">
                    <el-form-item prop="name" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Name<span class="text__colour-red">*</span></div>
                        <el-input v-model="price.name" class="layout__position-left">
                        </el-input>
                    </el-form-item>
                </div>
                <div class="layout__position-left layout__width-100 layout__margin-25-0">
                    <el-form-item prop="description" class="">
                        <p class="text_colour-909399 text__size-16">Description</p>
                        <el-input type="textarea" :rows="3" v-model="price.description"
                                  class="layout__position-left">
                        </el-input>
                    </el-form-item>
                </div>

                <div class="component__forms-3">
                    <el-form-item prop="press" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Press</div>
                        <el-select v-model="price.press" placeholder="Select Press" clearable="true">
                            <el-option
                                    v-for="press in ravensworth.press.options"
                                    :key="press.id"
                                    :label="press.text"
                                    :value="press.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="paperWeight" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Paper Weight</div>
                        <el-input autofocus v-model="price.paperWeight" class="layout__position-left">
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="sellPrice" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Default Sell Price<span
                                class="text__colour-red">*</span></div>
                        <el-input v-model="price.sellPrice" class="layout__position-left">
                        </el-input>
                    </el-form-item>
                </div>


                <div class="component__forms-3">

                    <el-form-item prop="style" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Style</div>
                        <el-input v-model="price.style" class="layout__position-left">
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="paperType" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Paper Type</div>
                        <el-input v-model="price.paperType" class="layout__position-left">
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="costPrice" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Cost Price</div>
                        <el-input v-model="price.costPrice" class="layout__position-left">
                        </el-input>
                    </el-form-item>
                </div>
                <div class="component__forms-3">
                    <el-form-item prop="isoSize" class="component__forms__fields">
                        <div class="component__forms__fields__labels">ISO Size</div>
                        <el-select v-model="price.isoSize" placeholder="Select ISO Size" clearable="true">
                            <el-option
                                    v-for="iso in ravensworth.isoSize.options"
                                    :key="iso.id"
                                    :label="iso.text"
                                    :value="iso.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="finishing" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Finishing</div>
                        <el-select v-model="price.finishing" placeholder="Select Finishing" clearable="true">
                            <el-option
                                    v-for="finishing in ravensworth.finishingType.options"
                                    :key="finishing.id"
                                    :label="finishing.text"
                                    :value="finishing.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="minQty" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Default Min Qty</div>
                        <el-input v-model="price.minQty" class="layout__position-left">
                        </el-input>
                    </el-form-item>
                </div>


            </el-form>

            <div class="layout__position-right layout__width-50">
                <el-button class="button-red button__base__admin layout__position-right">Delete</el-button>
                <el-button class="button-teal button__base__admin layout__position-right layout__margin__right-20px"
                           v-on:click="">Cancel Changes
                </el-button>
                <el-button class="button-red button__base__admin layout__position-right layout__margin__right-20px"
                           v-on:click="updatePrice('price')">Save Changes
                </el-button>
            </div>

        </div>
    </div>

</template>

<script>

    import Axios from 'axios';
    import {axios} from '@/mixins/Axios.js';
    import {csvDownloadHelper} from '@/mixins/CsvDownloadHelper.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import {backing} from '@/mixins/Backing.js';

    export default {
        name: "createCustomers",
        mixins: [axios, csvDownloadHelper, dataFormatter, backing],
        props: {
            price: {}
        },
        data() {
            return {
                // price: {
                //     sample: ''
                //
                // },
                types: [],
                statuses: [],
                presses: [],
                isos: [],
                finishings: [],
                rules: {
                    code: [{
                        required: true,
                        message: 'price code required',
                        trigger: 'blur'
                    }],
                    name: [{
                        required: true,
                        message: 'name required',
                        trigger: 'blur'
                    }],
                    sellPrice: [{
                        required: true,
                        message: 'default sell price required',
                        trigger: 'blur'
                    }],
                }
            }
        },
        created() {
            this.isUserAuthorised();
        },
        methods: {
            updatePrice(price) {
                this.$refs[price].validate((valid) => {
                    if (valid) {
                        console.log('done post')
                        // todo need to have session storage for view price page

                    } else {
                        return false;
                    }
                })
            }
        }
    };
</script>